<script>
  import { FileImageOutline } from 'flowbite-svelte-icons';

  export let src = null;
  export let alt = null;

  let useFallback = !src;
  const onError = () => {
    useFallback = true;
  };
</script>

{#if useFallback}
  <FileImageOutline {...$$props} strokeWidth="1" />
{:else}
  <img {alt} {src} {...$$props} on:error={onError} />
{/if}
